import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

type SpinnerProps = {
    tag?: string,
    className?: string,
    size?: 'lg' | 'md' | 'sm' | null,
    type?: 'bordered' | 'grow',
    color?: string,
    children?: PropTypes.object,
};

/**
 * Spinner
 */
const Spinner = ({
    tag = 'div',
    className,
    size,
    type = 'bordered',
    color = 'primary',
    children,
}: SpinnerProps) => {
    const spinnerChildren = children || null;
    const Tag = tag;

    return (
        <Tag
            role="status"
            className={classNames(
                { 'spinner-border': type === 'bordered', 'spinner-grow': type === 'grow' },
                [`text-${color}`],
                { [`avatar-${size}`]: size },
                className
            )}>
            {spinnerChildren}
        </Tag>
    );
};

export default Spinner;
